module.exports = __webpack_public_path__ + "assets/img/bg_服务站.f11a3bf5.png";